<template lang="pug">
Response(
    view="error"
    title="Оплата отклонена"
    description="Дополнительные детали о платеже доступны в приложении банка"
)
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { Response } from '@/shared/ui/Response'

export default defineComponent({
    name: 'ErrorState',
    components: { Response },
})
</script>
